<div class="form-field">
  <label for="user_filter">{{'user'| translation}}</label>
  <br>
  <input pInputText [(ngModel)]="user_filter" [placeholder]="'user_filter'| translation" name="user_filter"/>
</div>

